import { CaptionPresetName } from './types';
import * as presets from './presets';
import { CaptionStyles } from '@/domains/asset';

export function getCaptionPreset(name: CaptionPresetName): Partial<CaptionStyles> {
  return presets[name];
}

export function getAvailablePresetNames(): CaptionPresetName[] {
  return [
    'sassy',
    'silicon',
    'beast',
    'bouncy',
    'neo',
    'snazzy',
    'sleek',
    'simpleBold',
    'prof',
    'funky',
    'neon',
    'corporate',
    'marker',
    'romantic',
    'sign'
  ] as CaptionPresetName[];
}
